const API_BASE_URL = process.env.NODE_ENV === "development" ? 'http://localhost:5000/api/dashboard' : `${window.origin}/api/dashboard`
// const API_BASE_URL = `http://le-dev.ap-southeast-1.elasticbeanstalk.com/api/dashboard`
// console.log(process.env);

export default {
    API_BASE_URL
}
